import { ShipmentStatus } from "../../../../types/ShipmentStatus";

// disables editing of an input based on shipment status
export const disableInput = (shipmentStatus: ShipmentStatus, allowedStatuses: ShipmentStatus[]) => {
  return !allowedStatuses.includes(shipmentStatus);
};
